/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Invalid_CredentialInputs */

const en_login_error_invalid_credential = /** @type {(inputs: Login_Error_Invalid_CredentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid email or password.`)
};

const fr_login_error_invalid_credential = /** @type {(inputs: Login_Error_Invalid_CredentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email ou mot de passe invalide.`)
};

const de_login_error_invalid_credential = /** @type {(inputs: Login_Error_Invalid_CredentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültige E-Mail-Adresse oder ungültiges Passwort.`)
};

const it_login_error_invalid_credential = /** @type {(inputs: Login_Error_Invalid_CredentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email o password non valide.`)
};

const ru_login_error_invalid_credential = /** @type {(inputs: Login_Error_Invalid_CredentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неверный адрес электронной почты или пароль.`)
};

const es_login_error_invalid_credential = /** @type {(inputs: Login_Error_Invalid_CredentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico o contraseña no válidos.`)
};

const zh_cn2_login_error_invalid_credential = /** @type {(inputs: Login_Error_Invalid_CredentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮箱或密码无效。`)
};

const ja_login_error_invalid_credential = /** @type {(inputs: Login_Error_Invalid_CredentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレスまたはパスワードが無効です。`)
};

const hi_login_error_invalid_credential = /** @type {(inputs: Login_Error_Invalid_CredentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गलत ईमेल या पासवर्ड।`)
};

const pt_pt2_login_error_invalid_credential = /** @type {(inputs: Login_Error_Invalid_CredentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail ou senha inválidos.`)
};

/**
* | output |
* | --- |
* | "Invalid email or password." |
*
* @param {Login_Error_Invalid_CredentialInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_invalid_credential = /** @type {((inputs?: Login_Error_Invalid_CredentialInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Invalid_CredentialInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_error_invalid_credential(inputs)
	if (locale === "de") return de_login_error_invalid_credential(inputs)
	if (locale === "it") return it_login_error_invalid_credential(inputs)
	if (locale === "ru") return ru_login_error_invalid_credential(inputs)
	if (locale === "es") return es_login_error_invalid_credential(inputs)
	if (locale === "zh-CN") return zh_cn2_login_error_invalid_credential(inputs)
	if (locale === "ja") return ja_login_error_invalid_credential(inputs)
	if (locale === "hi") return hi_login_error_invalid_credential(inputs)
	if (locale === "pt-PT") return pt_pt2_login_error_invalid_credential(inputs)
	return en_login_error_invalid_credential(inputs)
});